<template lang='pug'>
Dialog2
  template(
    v-slot:dialog
  )
    v-card(
      flat
    )
      v-card-title
        | Water Consumption
      v-card-text
        v-text-field(
          v-if='unit === "milliliters"'
          autocomplete='off'
          label='Milliliters'
          type='number'
          :value='millilitersNew'
          @change='result => millilitersNew = result'
        )
        v-text-field(
          v-if='unit === "cups"'
          autocomplete='off'
          label='Cups'
          type='number'
          :value='cupsNew'
          @change='setCups'
        )
        v-text-field(
          v-if='unit === "ounces"'
          autocomplete='off'
          label='Fluid Ounces'
          type='number'
          :value='ouncesNew'
          @change='setOunces'
        )
        v-hover(
          v-if='unit === "milliliters"'
          v-slot='{ hover }'
        )
          v-btn.mr-2(
            @click='addMilliliters(100)'
            elevation='0'
          )
            v-icon(
              left
            )
              template(
                v-if='hover'
              )
                | mdi-plus
              template(
                v-else
              )
                | mdi-plus-outline
            | 100
        v-hover(
          v-if='unit === "milliliters"'
          v-slot='{ hover }'
        )
          v-btn.mr-2(
            @click='addMilliliters(1000)'
            elevation='0'
          )
            v-icon(
              left
            )
              template(
                v-if='hover'
              )
                | mdi-plus
              template(
                v-else
              )
                | mdi-plus-outline
            | 1000
        v-hover(
          v-if='unit === "cups"'
          v-slot='{ hover }'
        )
          v-btn.mr-2(
            @click='addCups(1)'
            elevation='0'
          )
            v-icon(
              left
            )
              template(
                v-if='hover'
              )
                | mdi-plus
              template(
                v-else
              )
                | mdi-plus-outline
            | 1
        v-hover(
          v-if='unit === "cups"'
          v-slot='{ hover }'
        )
          v-btn.mr-2(
            @click='addCups(8)'
            elevation='0'
          )
            v-icon(
              left
            )
              template(
                v-if='hover'
              )
                | mdi-plus
              template(
                v-else
              )
                | mdi-plus-outline
            | 8
        v-hover(
          v-if='unit === "ounces"'
          v-slot='{ hover }'
        )
          v-btn.mr-2(
            @click='addOunces(1)'
            elevation='0'
          )
            v-icon(
              left
            )
              template(
                v-if='hover'
              )
                | mdi-plus
              template(
                v-else
              )
                | mdi-plus-outline
            | 1
        v-hover(
          v-if='unit === "ounces"'
          v-slot='{ hover }'
        )
          v-btn.mr-2(
            @click='addOunces(8)'
            elevation='0'
          )
            v-icon(
              left
            )
              template(
                v-if='hover'
              )
                | mdi-plus
              template(
                v-else
              )
                | mdi-plus-outline
            | 8
      v-card-actions
        v-hover(
          v-slot='{ hover }'
        )
          v-btn(
            text
            @click='save'
          )
            v-icon(
              left
            )
              template(
                v-if='hover'
              )
                | mdi-check
              template(
                v-else
              )
                | mdi-check-outline
            | Save
  template(
    v-slot:default='{ shouldShowDialogUpdate }'
  )
    v-card(
      flat
    )
      v-card-title
        | Water Consumption
      v-card-text
        v-radio-group(
          :value='unit'
          @change='changeUnit'
          label='How would you like to measure water?'
        )
          v-radio(
            label='Milliliters'
            value='milliliters'
          )
          v-radio(
            label='Cups'
            value='cups'
          )
          v-radio(
            label='Ounces'
            value='ounces'
          )
        v-text-field(
          v-if='unit === "milliliters"'
          autocomplete='off'
          label='Milliliters'
          type='number'
          :value='millilitersOld'
          filled
          readonly
        )
        v-text-field(
          v-if='unit === "cups"'
          autocomplete='off'
          label='Cups'
          type='number'
          :value='cupsOld'
          filled
          readonly
        )
        v-text-field(
          v-if='unit === "ounces"'
          autocomplete='off'
          label='Fluid Ounces'
          type='number'
          :value='ouncesOld'
          filled
          readonly
        )
      v-card-actions
        v-hover(
          v-slot='{ hover }'
        )
          v-btn(
            text
            @click='shouldShowDialogUpdate(true)'
          )
            v-icon(
              left
            )
              template(
                v-if='hover'
              )
                | mdi-pencil
              template(
                v-else
              )
                | mdi-pencil-outline
            | Edit
</template>

<script>
import { waterGet } from '../functions/waterGet';
import { waterSet } from '../functions/waterSet';

import { date_to_date_int } from '@thomasphan/helpers-fatsecret';

import Dialog2 from './Dialog2.vue';

import { pipe, set } from 'lodash/fp';

import Decimal from 'decimal.js';

const millilitersPerCup = 236.588;
const millilitersPerOunce = millilitersPerCup / 8;

const save = async function ()
{
  await waterSet
  (this?.date_int)
  (this?.millilitersSanitized);

  this?.$emit?.('update:milliliters', this?.millilitersSanitized);
};

const date_int = function ()
{
  return date_to_date_int(this?.date);
};

const millilitersSanitized = function ()
{
  return window.Number(this?.millilitersNew);
};

const cupsOld = function ()
{
  return new Decimal(this?.millilitersOld)
  .div(millilitersPerCup)
  .toNumber();
};

const cupsNew = function ()
{
  return new Decimal(this?.millilitersSanitized)
  .div(millilitersPerCup)
  .toNumber();
};

const ouncesOld = function ()
{
  return new Decimal(this?.millilitersOld)
  .div(millilitersPerOunce)
  .toNumber();
};

const ouncesNew = function ()
{
  return new Decimal(this?.millilitersSanitized)
  .div(millilitersPerOunce)
  .toNumber();
};

const mounted = async function ()
{
  this.millilitersOld = this.millilitersNew = await waterGet(this?.date_int) || 0;
};

const unit = function ()
{
  return this?.preferencesUnit?.water;
};

const changeUnit = function (unit)
{
  pipe
  ([
    set('water')(unit),
    preferencesUnit => this.$emit('update:preferencesUnit', preferencesUnit),
  ])
  (this?.preferencesUnit);
};

const addMilliliters = function (milliliters)
{
  this.millilitersNew = this?.millilitersSanitized + milliliters;
};

const addCups = function (cups)
{
  this.millilitersNew = new Decimal(millilitersPerCup)
  .mul(cups)
  .add(this?.millilitersSanitized)
  .toNumber();
};

const addOunces = function (ounces)
{
  this.millilitersNew = new Decimal(millilitersPerOunce)
  .mul(ounces)
  .add(this?.millilitersSanitized)
  .toNumber();
};

const setCups = function (cups)
{
  this.millilitersNew = new Decimal(millilitersPerCup)
  .mul(cups || 0)
  .toNumber();
};

const setOunces = function (ounces)
{
  this.millilitersNew = new Decimal(millilitersPerOunce)
  .mul(ounces || 0)
  .toNumber();
};

export default
{
  components:
  {
    Dialog2,
  },
  computed:
  {
    date_int,
    cupsOld,
    cupsNew,
    ouncesOld,
    ouncesNew,
    millilitersSanitized,
    unit,
  },
  data()
  {
    return {
      millilitersOld: 0,
      millilitersNew: 0,
      millilitersPerCup,
      millilitersPerOunce,
    };
  },
  methods:
  {
    addCups,
    addMilliliters,
    addOunces,
    setCups,
    setOunces,
    changeUnit,
    save,
  },
  mounted,
  props:
  {
    date: { required: true },
    preferencesUnit: { required: true },
  },
};
</script>